import { render, staticRenderFns } from "./AuthorizeAgent.vue?vue&type=template&id=8f06215a&scoped=true&"
import script from "./AuthorizeAgent.vue?vue&type=script&lang=js&"
export * from "./AuthorizeAgent.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizeAgent.vue?vue&type=style&index=0&id=8f06215a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f06215a",
  null
  
)

export default component.exports